var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"search-config":_vm.searchConfig,"table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total,"current-page":_vm.page},on:{"onSearch":_vm.onSearch,"onReset":function($event){_vm.search=null},"onChangePage":_vm.changeCurrentPage,"onHandle":_vm.tableHandle}})
}
var staticRenderFns = []

export { render, staticRenderFns }